// src/components/LocationControl.js
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

const LocationControl = ({ onClearSearch }) => {
  const map = useMap();

  useEffect(() => {
    // Create a new Leaflet control at the bottom left
    const control = L.control({ position: 'bottomleft' });
    const container = L.DomUtil.create(
      'div',
      'leaflet-bar leaflet-control leaflet-control-custom'
    );

    // Style the container for our custom button
    container.style.backgroundColor = 'white';
    container.style.width = '35px';
    container.style.height = '35px';
    container.style.display = 'flex';
    container.style.alignItems = 'center';
    container.style.justifyContent = 'center';
    container.style.cursor = 'pointer';
    container.title = 'Go to My Current Location';

    // Set the inner HTML to an image (make sure the file exists in your public folder)
    container.innerHTML = `<img src="/location-icon.png" alt="Location" style="width:100%; height:100%;" />`;

    // Disable click propagation so clicks on the icon don't bubble up
    L.DomEvent.disableClickPropagation(container);

    // Define what happens when the container (button) is clicked
    container.onclick = () => {
      // Call the parent's clear callback (if provided) to clear the search bar
      if (onClearSearch) {
        onClearSearch();
      }

      // Get the current geolocation and recenter the map.
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            // Re-center the map to the current location with an appropriate zoom level
            map.setView([lat, lng], 18);
          },
          (error) => {
            console.error("Error obtaining geolocation:", error);
            alert("Unable to retrieve your location.");
          }
        );
      } else {
        alert("Geolocation is not supported by your browser.");
      }
    };

    // Set the onAdd method for the control
    control.onAdd = () => container;

    // Add the control to the map
    control.addTo(map);

    // Cleanup: recrosshairmove the control when the component unmounts
    return () => {
      control.remove();
    };
  }, [map, onClearSearch]);

  return null;
};

export default LocationControl;